export function appendRowColHeaderAttributes(domNode, colIdx, rowIdx) {
  if (rowIdx != null) {
    domNode.setAttribute('data-test-row-header-idx', rowIdx)
  }
  if (colIdx != null) {
    domNode.setAttribute('data-test-col-header-idx', colIdx)
  }
}
